import { motion } from "framer-motion";
import { useLang } from "../context/LangContext";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 },
};

export default function About() {
  const { t } = useLang();

  return (
    <section id="about" className="py-24 md:py-32 bg-background border-b border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <motion.h2
              {...fadeUp}
              className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground mb-8"
            >
              {t.about.title}
            </motion.h2>

            <motion.ul
              initial="initial"
              whileInView="visible"
              viewport={{ once: true }}
              variants={{
                initial: {},
                visible: { transition: { staggerChildren: 0.08, delayChildren: 0.2 } },
              }}
              className="space-y-3"
            >
              {t.about.highlights.map((h, i) => (
                <motion.li
                  key={i}
                  variants={{
                    initial: { opacity: 0, x: -12 },
                    visible: { opacity: 1, x: 0 },
                  }}
                  className="text-muted-foreground text-sm md:text-base pl-4 border-l-2 border-primary/40"
                >
                  {h}
                </motion.li>
              ))}
            </motion.ul>
          </div>

          <div className="space-y-5">
            <motion.p
              {...fadeUp}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="text-base md:text-lg text-muted-foreground leading-relaxed"
            >
              {t.about.p1}
            </motion.p>
            <motion.p
              {...fadeUp}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-base md:text-lg text-muted-foreground leading-relaxed"
            >
              {t.about.p2}
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
}
